
export const theadStyles = {
  backgroundColor: 'whitesmoke',
  borderRadius: '5%',
  color: 'black',
  borderBottom: '4px solid lightgrey',
  fontWeight: '400'
};

export const tableStyles = {
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
};

export const thStyles = (props) => {
  return {
    fontWeight: '400',
    fontSize: '.9em',
    borderBottom: '4px solid ' + (props.borderColor ? props.borderColor : 'lightgrey'),
    textAlign: props.first ? null : "center",
    paddingBottom: '.5em',
    paddingTop: '1.05em',
    cursor: 'pointer'
  }
};

export const bodyTrStyles = {
  backgroundColor: 'white'
};

export const bodyTdStyles = {
  textAlign: 'center'
};

export const firstBodyTdStyles = {
  fontSize: '.9em',
  paddingTop: '1.42em',
  paddingLeft: '1.6em'
};
